export class Beneficiario {
    constructor(
        codigo?: string,
        nome?: string,
        idade?: string,
        nomeTitular?: string,
        empresa?: string,
        plano?: string,
        telefoneResidencial?: string,
        telefoneComercial?: string,
        public telefoneCelContato?: string,
        elegivel?: string,
        tipo?: string        
    ){}
    
    get codigo(): string{
        return this.codigo;
    }
    
    get nome(): string{
    	return this.nome;
    }

    get elegivel(): string{ 
        return this.elegivel;
    }

}


// WEBPACK FOOTER //
// ./src/app/components/base/vo/beneficiario.ts